import React from 'react';
import Circles from './backgroundElements/Circles.style';
import SlashLines from './backgroundElements/SlashLines.style';
import LoginBackgroundContainer from './LoginBackground.style';

const LoginBackground = () => (
  <LoginBackgroundContainer>
    <SlashLines />
    <Circles />
  </LoginBackgroundContainer>
);

export default LoginBackground;
